import { createContext, useState } from "react";
import { getPreferences } from "../utils/helpers";

const InteractiveContext = createContext({});

export const InteractiveProvider = ({ children }) => {
  const [menu, setMenu] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [filters, setFilters] = useState(null);
  const [showNotifs, setShowNotifs] = useState(false);
  const [view, setView] = useState(getPreferences().view);
  const [addNewEvent, setAddNewEvent] = useState(false);
  const [type, setType] = useState(null);
  const [event, setEvent] = useState(null);
  const [showCategory, setShowCategory] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showFullDatePicker, setShowFullDatePicker] = useState(false);
  const [hideMenuNav, setHideMenuNav] = useState(true);
  const [addEventWithStartEndTime, setAddEventWithStartEndTime] = useState({
    start: null,
    end: null,
  });

  return (
    <InteractiveContext.Provider
      value={{
        menu,
        showLogin,
        view,
        addNewEvent,
        type,
        showNotifs,
        event,
        filters,
        showDatePicker,
        showCategory,
        showFullDatePicker,
        hideMenuNav,
        addEventWithStartEndTime,
        setAddEventWithStartEndTime,
        setHideMenuNav,
        setShowFullDatePicker,
        setShowDatePicker,
        setShowCategory,
        setFilters,
        setEvent,
        setShowNotifs,
        setType,
        setAddNewEvent,
        setView,
        setMenu,
        setShowLogin,
      }}
    >
      {children}
    </InteractiveContext.Provider>
  );
};

export default InteractiveContext;
